var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLocalServerAdmins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3B454D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 17.223h-2.25a.21.21 0 0 1-.194-.132 2.067 2.067 0 0 0-3.86 0 .21.21 0 0 1-.194.131H5.625a.625.625 0 1 0 0 1.25h2.25a.21.21 0 0 1 .194.133 2.067 2.067 0 0 0 3.86 0 .21.21 0 0 1 .194-.133h2.25a.625.625 0 1 0 0-1.25h.002zM10 18.68a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667zM1.667 17.848a.625.625 0 0 0-.625-.625H.625a.625.625 0 1 0 0 1.25h.417a.625.625 0 0 0 .625-.625zM3.125 17.223a.625.625 0 1 0 0 1.25h.417a.625.625 0 1 0 0-1.25h-.417zM16.458 17.223a.625.625 0 0 0 0 1.25h.417a.625.625 0 1 0 0-1.25h-.417zM19.375 17.223h-.417a.625.625 0 0 0 0 1.25h.417a.625.625 0 1 0 0-1.25zM16.667 12.083c.92 0 1.666-.746 1.666-1.666v-8.75c0-.92-.746-1.667-1.666-1.667H3.333c-.92 0-1.666.746-1.666 1.667v8.75c0 .92.746 1.666 1.666 1.666h5.625c.115 0 .209.094.209.209v.833a.208.208 0 0 1-.209.208H4.792a.833.833 0 0 0 0 1.667h10.416a.833.833 0 1 0 0-1.667h-4.166a.208.208 0 0 1-.209-.208v-.833c0-.115.094-.209.209-.209h5.625zm-.209-10.416c.115 0 .209.093.209.208v7.083a.208.208 0 0 1-.209.209H3.542a.208.208 0 0 1-.209-.209V1.875c0-.115.094-.208.209-.208h12.916z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLocalServerAdmins);
export default __webpack_public_path__ + "static/media/total-local-server-admins.60c27817fdf517a5e00145265dc69b26.svg";
export { ForwardRef as ReactComponent };